import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  GET_ALL_PERMISSIONS: 'getAllPermissions'
}

export const globalActions = getNamespacedBy('permission', actionTypes)



// WEBPACK FOOTER //
// ./src/store/module/permission/actionTypes.js